const ITEMS = [
  "Rats / Souris",
  "Guêpes / Frelons",
  "Puces",
  "Fourmis",
  "Blattes / Cafards",
  "Moustiques",
  "Chenilles processionnaires",
  "Punaises de lit",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display uppercase text-3xl md:text-5xl tracking-tight text-outline px-6 md:px-10 whitespace-nowrap">
          {item}
        </span>
        <span className="h-3 w-3 md:h-4 md:w-4 bg-[#E50914] shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="pest-marquee"
    className="overflow-hidden border-y border-black py-5 md:py-7 bg-white"
    aria-hidden="true"
  >
    <div className="marquee-track flex">
      <Row />
      <Row />
    </div>
  </div>
);
